import { Grid } from '@mui/material';
import { memo } from 'react';
import { AccordionCancelMarriage } from 'mutation/view-models/cancel-marriage';
import { FormikErrors, FormikTouched } from 'formik';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import CourtTypeList from 'shell/components/shared/court-type-list';
// import ForeignState from './foreign-state';
// import ItalianState from './italian-state';
import PmiDivider from 'shell/components/shared/divider';

interface JudgmentProps {
  values?: AccordionCancelMarriage;
  onChange: (
    key: keyof AccordionCancelMarriage,
    value: AccordionCancelMarriage[keyof AccordionCancelMarriage]
  ) => void;
  errors?: FormikErrors<AccordionCancelMarriage>;
  touched?: FormikTouched<AccordionCancelMarriage>;
}

const JudgmentComponent = ({
  values,
  onChange,
  touched,
  errors,
}: JudgmentProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12}>
        <PmiDivider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Sentenza</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Nr"
          aria-label="Numero"
          id="number"
          name="number"
          fullWidth
          inputProps={{
            maxLength: '20',
          }}
          onChange={(event) => {
            onChange('number', event?.target.value);
          }}
          value={values?.number || ''}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data sentenza *"
          aria-label="Data sentenza"
          value={values?.dateJudgment || null}
          onChange={(date) => {
            onChange('dateJudgment', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              id="dateJudgment"
              {...params}
              fullWidth
              helperText={errors?.dateJudgment}
              error={touched?.dateJudgment && Boolean(errors?.dateJudgment)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data validità *"
          aria-label="Data validità"
          value={values?.dateValidity || null}
          onChange={(date) => {
            onChange('dateValidity', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              id="dateValidity"
              {...params}
              fullWidth
              helperText={errors?.dateValidity}
              error={touched?.dateValidity && Boolean(errors?.dateValidity)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Autorità *"
          aria-label="Autorità"
          id="authority"
          name="authority"
          fullWidth
          inputProps={{
            maxLength: '120',
          }}
          onChange={(event) => {
            onChange('authority', event?.target.value);
          }}
          value={values?.authority || ''}
          helperText={errors?.authority}
          error={touched?.authority && Boolean(errors?.authority)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CourtTypeList
          required
          label="Tipo tribunale"
          aria-label="Tipo tribunale"
          value={values?.courtType || ''}
          onChange={(value) => onChange('courtType', value)}
          error={touched?.courtType && Boolean(errors?.courtType)}
        />
      </Grid>
      {/* <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Autorità"
            id="isForeign"
            value={values?.isForeign || 'false'}
            onChange={() => onChange('isForeign', !values?.isForeign)}
          >
            <FormControlLabel value="false" control={<Radio />} label="Autorità italiana" />
            <FormControlLabel value="true" control={<Radio />} label="Autorità estera" />
          </RadioGroup>
        </FormControl>
      </Grid>
      {values?.isForeign ? (
        <ForeignState values={values} onChange={onChange} errors={errors} touched={touched} />
      ) : (
        <ItalianState values={values} onChange={onChange} errors={errors} touched={touched} />
      )} */}
    </Grid>
  );
};

JudgmentComponent.displayName = 'Judgment - Cancel marriage accordion component';

const Judgment = memo(JudgmentComponent);

export default Judgment;
